import { BaseCustomElement, AjaxSubmit } from "brut-js"

class DashboardRateMealDialog extends BaseCustomElement {
  static tagName = "cc-dashboard-rate-meal-dialog"

  static observedAttributes = [
    "show-warnings",
    "form-action",
    "meal-name",
    "current-rating",
  ]


  #formAction = null
  #mealName = null
  #currentRating = null

  formActionChangedCallback({newValue}) {
    this.#formAction = newValue
  }

  mealNameChangedCallback({newValue}) {
    this.#mealName = newValue
  }

  currentRatingChangedCallback({newValue}) {
    this.#currentRating = newValue
  }

  showModal() {
    const dialog = this.querySelector("dialog")
    if (!dialog) {
      this.logger.error("Could not find dialog element inside the rate meal dialog component")
      return
    }

    const form = dialog.querySelector("form")
    if (form) {
      form.setAttribute("action", this.#formAction)
      form.querySelectorAll("input[name=rating]").forEach( (input) => {
        if (input.value === this.#currentRating) {
          input.checked = true
        } else {
          input.checked = false
        }
      })
    } 
    else {
      this.logger.error("Could not find form element inside the rate meal dialog component")
    }

    const mealNameSlot = dialog.querySelector("slot[name=meal-name]")
    if (mealNameSlot) {
      mealNameSlot.textContent = this.#mealName || "the meal"
    }

    this.querySelectorAll(AjaxSubmit.tagName).forEach( (ajaxSubmit) => {
      ajaxSubmit.addEventListener("brut:submitok", this.#okListener)
    })

    dialog.showModal()
  }

  #okListener = (event) => {
    window.location.reload()
  }

  #closeDialog = (event) => {
    event.preventDefault()
    const dialog = this.querySelector("dialog")
    if (!dialog) {
      this.logger.error("Could not find dialog element inside the rate meal dialog component")
      return
    }
    dialog.close()
  }

  update() {
    this.querySelectorAll("button[type=reset]").forEach( (button) => {
      button.addEventListener("click", this.#closeDialog)
    })
    this.querySelectorAll("a[aria-label=Close]").forEach( (button) => {
      button.addEventListener("click", this.#closeDialog)
    })
  }
}
export default DashboardRateMealDialog
